module.exports = __webpack_public_path__ + "img/img-idCardUpload.@2x.502bf9b9.png";